import { NgModule } from '@angular/core';
import { SharedModule } from '../../shared/shared.module';
import { RouterModule } from '@angular/router';

// Components
import { FlagManagerNewDesignComponent } from './flag-manager.component';
import { FlagMangerHeaderComponent } from './components/flag-manger-header/flag-manger-header.component';
import { CalendarModalComponent } from './components/calendar-modal/calendar-modal.component';
import { FlagManagerSidebarComponent } from './components/flag-manager-sidebar/flag-manager-sidebar.component';
import { InspectionCommentsComponent } from './components/inspection-comments/inspection-comments.component';
import { FlagManagerFullViewComponent } from './components/flag-manager-full-view/flag-manager-full-view.component';
import { FlagManagerTopBarComponent } from './components/flag-manager-top-bar/flag-manager-top-bar.component';
import { FlagImageSectionComponent } from './components/flag-manager-image-section/flag-image-section.component';
import { FlagManagerIssueDetailComponent } from './components/flag-manager-issue-detail/flag-manager-issue-detail.component';
import { FlagManagerEditGroupComponent } from './components/flag-manager-edit-group/flag-manager-edit-group.component';
import { GroupNameModalComponent } from './components/group-name-modal/group-name-modal.component';
import { FlagResolveTopbarComponent } from './components/flag-resolve-topbar/flag-resolve-topbar.component';
import { FlagManagementBarComponent } from './components/flag-management-snake-bar/flag-management-bar.component';

import { FlagUnlinkConfirmModalComponent } from './components/flag-unlink-confirm-modal/flag-unlink-confirm-modal.component';

// Services
import { FlagManagerService } from './flag-manager.service';
import { GroupManagementBarComponent } from './components/group-management-snake-bar/group-management-bar.component';
import { GenerateLetterModalComponent } from './components/generate-letter-modal/generate-letter-modal.component';
import { FlagManagerGroupPickerComponent } from './components/flag-manager-group-picker/flag-manager-group-picker.component';
import { LetterHistoryPanelComponent } from './components/letter-history-panel/letter-history-panel.component';

@NgModule({
  declarations: [
    FlagManagerNewDesignComponent,
    FlagMangerHeaderComponent,
    CalendarModalComponent,
    FlagManagerSidebarComponent,
    InspectionCommentsComponent,
    FlagManagerFullViewComponent,
    FlagManagerTopBarComponent,
    FlagImageSectionComponent,
    FlagManagerIssueDetailComponent,
    FlagManagerEditGroupComponent,
    GroupNameModalComponent,
    FlagResolveTopbarComponent,
    FlagManagementBarComponent,
    GroupManagementBarComponent,
    FlagManagerGroupPickerComponent,
    GenerateLetterModalComponent,
    FlagUnlinkConfirmModalComponent,
    LetterHistoryPanelComponent,
  ],
  imports: [SharedModule, RouterModule],
  providers: [FlagManagerService],
  exports: [
    FlagManagerNewDesignComponent,
    FlagMangerHeaderComponent,
    CalendarModalComponent,
    FlagManagerSidebarComponent,
    InspectionCommentsComponent,
    FlagManagerFullViewComponent,
    FlagManagerTopBarComponent,
    FlagImageSectionComponent,
    FlagManagerIssueDetailComponent,
    FlagManagerEditGroupComponent,
    GroupNameModalComponent,
    FlagResolveTopbarComponent,
    FlagManagementBarComponent,
    GroupManagementBarComponent,
    FlagManagerGroupPickerComponent,
    GenerateLetterModalComponent,
    FlagUnlinkConfirmModalComponent,
    LetterHistoryPanelComponent,
  ],
})
export class FlagManagerModule {}
